import React from "react";
import "../styles/footer.scss";
import { MountainTransition } from "../components/MountainTransition";
import { NavLink } from "react-router-dom";

export const Footer = () => {
  return (
    <div>
      <div className="footer">
        Made with <span>&#9829;</span> in Austria
      </div>
    </div>
  );
};
